(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FHIRIGDOC", [], factory);
	else if(typeof exports === 'object')
		exports["FHIRIGDOC"] = factory();
	else
		root["FHIRIGDOC"] = factory();
})(self, () => {
return 